import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNinjaFormsRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#EE4A4D",
			d: "M6.5 3.7h17.6q.9.1 1.5.7 1 .8 1.1 2V24q-.1.9-.7 1.5-.8 1-2.1 1.1H6.2q-.9-.2-1.5-.8-.9-.8-1-2V6.3a3 3 0 0 1 2.8-2.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#424243",
			d: "M19.4 13.5a6 6 0 0 1 2.6-2q.7-.3 1.6-.4c.2 0 .7 0 .6.3 0 .5-1 1.3-1.3 1.6.3.2 1.3.9 1.5 1.2l-.6.2q-1.6.3-3.1.8.6 1.2.9 2.5l.1 1.6H6.1l.1-1.6a8 8 0 0 1 3-4.9q2.1-1.6 4.7-1.6a8 8 0 0 1 4.9 1.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "M7.4 19.3a3 3 0 0 1 1-2.2l1.4-.9q2.3-1 4.8-1c1.9.2 4 .7 5.4 2.1q.7.9.7 2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#424243",
			d: "M16 19.3q0-.6.4-1c.8-.5 1.2.3 1.2 1zm-5.8 0c0-.6.4-1.5 1.2-1q.4.4.4 1z"
		})
	]
});
export default SvgNinjaFormsRegularIcon;
